module.exports = __webpack_public_path__ + "static/description-bg-dbc9aafa7809277b051b3a24ffc09e68.png";